export default __webpack_public_path__ + "static/media/2480.4544e446.svg";